export const getRevenueColumns = () => ([
    {
        headerClassName: 'charge-item-header',
        fieldHeader: 'Charge Item',
        accessor: 'chargeItem',
        show: true,
    },
    {
        headerClassName: 'item-description-header',
        fieldHeader: 'Item Description',
        accessor: 'materialDescription',
        show: true,
    },
    {
        headerClassName: 'block-type-header',
        fieldHeader: 'Block Type',
        accessor: 'blockedType',
        show: true,
    },
    {
        headerClassName: 'bill-to-party-header',
        fieldHeader: 'Bill to Party',
        accessor: 'billToParty',
        show: true,
    },
    {
        headerClassName: 'bill-to-party-change-reason-header',
        fieldHeader: 'Bill to Party Change Reason',
        accessor: 'reasonCode',
        show: true,
    },
    {
        headerClassName: 'icb-header',
        fieldHeader: 'ICB',
        accessor: 'icbIndicator',
        show: true,
    },
    {
        headerClassName: 'quantity-header',
        fieldHeader: 'QTY',
        accessor: 'quantity',
        show: true,
    },
    {
        headerClassName: 'uom-header',
        fieldHeader: 'UOM',
        accessor: 'uom',
        show: true,
    },
    {
        headerClassName: 'unit-price-header',
        fieldHeader: 'Unit price',
        accessor: 'rate',
        show: true,
    },
    {
        headerClassName: 'currency-header',
        fieldHeader: 'Currency',
        accessor: 'condCurrency',
        show: true,
    },
    {
        headerClassName: 'amount-header',
        fieldHeader: 'Amount',
        accessor: 'total',
        show: true,
    },
    {
        headerClassName: 'vat-partner-header',
        fieldHeader: 'VAT Partner',
        accessor: 'vatPartner',
        show: true,
    },
    {
        headerClassName: 'vat-partner-change-reason-header',
        accessor: 'vatPartnerReasonCodeNo',
        fieldHeader: 'VAT Partner Change Reason',
        show: true,
    },
]);